import { render, staticRenderFns } from "./ImportUser.vue?vue&type=template&id=01badff3"
import script from "./ImportUser.vue?vue&type=script&lang=js"
export * from "./ImportUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports